export const DESKTOP_MEDIA_QUERY = "@media only screen and (min-width: 481px)";

export const GAME_STEPS = {
  cover: "COVER",
  instructions: "INSTRUCTIONS",
  dossier: "DOSSIER",
  topic: "TOPIC",
  summary: "SUMMARY",
  intro: "INTRO",
  game: "GAME",
  result: "RESULT"
};

export const HEADER_HEIGHT = 40;
export const DESKTOP_HEADER_HEIGHT = 130;

export const TEXTS_AT_LEVEL = 6;
export const LEVEL_TIME = 120;
